import { Injectable } from '@angular/core';
import { WizardService, WizardEventType } from '@farris/ui-wizard';
import { FrameContext } from '@farris/devkit';

@Injectable()
export class FormWizardService {
    constructor(
        private wizardSer: WizardService
    ) { }

    public preStep() {
        const currentPageId = this.wizardSer.getCurrentPageId();
        this.wizardSer.updateWizardState(WizardEventType.Prev, currentPageId);
    }
    public nextStep() {
        const currentPageId = this.wizardSer.getCurrentPageId();
        this.wizardSer.updateWizardState(WizardEventType.Next, currentPageId);
    }
    public cancelWizard() {
        this.wizardSer.cancelWizard();
    }

    public finishWizard() {
        this.wizardSer.finishWizard();
    }
}
